var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    fill: "#e7040f",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15,0C6.73,0,0,6.73,0,15s6.73,15,15,15,15-6.73,15-15S23.27,0,15,0ZM3.09,15c0-6.58,5.33-11.91,11.91-11.91,2.73,0,5.24.93,7.25,2.47L5.57,22.25c-1.54-2.01-2.47-4.52-2.47-7.25Zm11.91,11.91c-2.73,0-5.24-.93-7.25-2.47L24.43,7.75c1.54,2.01,2.47,4.52,2.47,7.25,0,6.58-5.33,11.91-11.91,11.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.6ddb396678c59719eb49738229fd74eb.svg";
export { ForwardRef as ReactComponent };